import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/components/elements/toast/toast.service';
import { AdsService } from 'src/app/shared/services/http-services/Ads/ads.service';
import { ViewAdComponent } from '../../../modules/Ads/ads-view/pages/view-ad/view-ad.component';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-ad-card',
  templateUrl: './ad-card.component.html',
  styleUrls: ['./ad-card.component.scss']
})
export class AdCardComponent implements OnInit {

  @Input() ad: any;
  @Input() isAll: boolean = false;

  @Output() adUpdated: EventEmitter<any> = new EventEmitter<any>();

  isImageError: boolean = false;
  isSaving: boolean = false;
  linkForm!: UntypedFormGroup;

  constructor(private adService: AdsService, private formBuilder: UntypedFormBuilder, private modalService: NgbModal, private toastService: ToastService, private cdr: ChangeDetectorRef, private confirmationService: ConfirmationModalComponent) {
    this.linkForm = this.formBuilder.group({
      link: ['']
    });
  }

  ngOnInit(): void {
    console.log("ad", this.ad);
  }

  onImageError(event: Event): void {
    this.isImageError = true;
  }

  openModal(model: any, event: any) {
    event?.stopPropagation();
    this.modalService.open(model, {
      size: 'md',
      centered: true,
    });
  }

  async addLink() {
    if (this.linkForm.invalid) {
      this.toastService.showDangerMessage('Please enter a valid link');
      return;
    }
    const result = await this.confirmationService.confirmationAlert((this.ad.link == null ? 'Add' : 'Change') + ' Link', 'Are you sure you want to add this link ?');

    if (!result) {
      return;
    }

    this.isSaving = true;

    const model = {
      AdID: this.ad.id,
      Link: this.linkForm.value.link
    }

    console.log("model", model);

    this.adService.AddLinkToAd(model).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        this.toastService.showSuccessMessage('Link added successfully');
        this.modalService.dismissAll();
        this.cdr.detectChanges();
        this.adUpdated.emit();
      },
      error: (err: any) => {
        this.isSaving = false;
        console.log(err);
        this.toastService.showDangerMessage('Failed to add link');
      }
    });
  }

  openAd() {
    const componentRef = this.modalService.open(ViewAdComponent, {
      size: 'lg',
      centered: true,
      backdrop: true
    });

    componentRef.componentInstance.ad = this.ad;
    componentRef.componentInstance.adUpdated.subscribe(() => {
      this.adUpdated.emit(); // re-emit to parent
    });

  }

  async removeAd(event: any) {
    event?.stopPropagation();

    const result = await this.confirmationService.confirmationAlert(
      'Delete Ad',
      'Are you sure you want to delete this ad? This action cannot be undone.'
    );

    if (!result) {
      return;
    }

    this.adService.DeleteAd(this.ad.id).subscribe({
      next: (res: any) => {
        if (res.succeeded) {
          this.toastService.showSuccessMessage('Ad deleted successfully');
          this.cdr.detectChanges();
          this.adUpdated.emit();
        }
      },
      error: (error) => {
        console.log(error);
        this.toastService.showError(error);
      }
    });
  }

}
